export function getLocationHref(): string {
  return window.location.href;
}

export function getLocationOrigin(): string {
  return window.location.origin;
}
